/* eslint-disable */
const noop = i => i;
const encode =
  window && window.encodeURIComponent ? window.encodeURIComponent : noop;
const decode =
  window && window.decodeURIComponent ? window.decodeURIComponent : noop;

function pickStringByIndentifier(str, identifier) {
  if (
    typeof identifier !== 'string' ||
    identifier.length !== 1 ||
    !str.length
  ) {
    return {
      rest: str,
      result: ''
    };
  }
  let identifierIndex = str.indexOf(identifier);
  let result = identifierIndex !== -1 ? str.slice(identifierIndex) : '';
  let rest = identifierIndex !== -1 ? str.slice(0, identifierIndex) : str;
  return {
    rest,
    result
  };
}

function resolveSearch(str) {
  let ret = {};
  if (!str) return ret;
  let arr = str.replace(/^\?/, '').split('&');
  let resolveArr = arr.map(item => {
    item = item.replace(/\+/g, ' ');
    let index = item.indexOf('=');
    let key = item.slice(0, index);
    let value = item.slice(index + 1).replace(/\?.*/, '');
    return [key, value].map(i => decode(i));
    // return item.split('=').map(item => decode(item))
  });
  resolveArr.forEach(item => {
    ret[item[0]] = item[1];
  });
  return ret;
}

/*
 * 解析字符串为字典格式
 * query: 默认为location.href
 */
function resolveQuery(query) {
  let search = '';
  let hash = '';
  let hashSearch;

  if (query) {
    let getHash = pickStringByIndentifier(query, '#');
    hash = getHash.result;
    let getSearch = pickStringByIndentifier(getHash.rest, '?');
    search = getSearch.result;
  } else {
    if (window && window.location) {
      search = window.location.search;
      hash = window.location.hash;
    }
  }

  hashSearch = pickStringByIndentifier(hash, '?').result;
  let searchObj = resolveSearch(search);
  let hashSearchObj = resolveSearch(hashSearch);
  return Object.assign({}, searchObj, hashSearchObj);
}

// 将字典格式拼接成字符串，带“?”
function stringifyQuery(obj) {
  const res = obj
    ? Object.keys(obj)
        .sort()
        .map(key => {
          const val = obj[key];

          if (val === undefined) {
            return '';
          }

          if (val === null) {
            return encode(key);
          }

          if (Array.isArray(val)) {
            const result = [];
            val.slice().forEach(val2 => {
              if (val2 === undefined) {
                return;
              }
              if (val2 === null) {
                result.push(encode(key));
              } else {
                result.push(encode(key) + '=' + encode(val2));
              }
            });
            return result.join('&');
          }

          return encode(key) + '=' + encode(val);
        })
        .filter(x => x.length > 0)
        .join('&')
    : null;
  return res ? `?${res}` : '';
}

function parseQuery(query) {
  const res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res;
  }
  query.split('&').forEach(param => {
    const parts = param.replace(/\+/g, ' ').split('=');
    const key = decode(parts.shift());
    const val = parts.length > 0 ? decode(parts.join('=')) : '';

    if (key === '') {
      return false;
    }
    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = val;
    }
  });

  return res;
}

// 拼接当前location的query
function concatLocalQuery(url = '', json = {}) {
  var objUrlQuery = resolveQuery(url);
  var objLocalQuery = resolveQuery(location.href);
  var newObjQuery = Object.assign({}, objUrlQuery, objLocalQuery, json);
  var strNewQuery = stringifyQuery(newObjQuery);
  var index = url.indexOf('?');
  return (index !== -1 ? url.slice(0, index) : url.slice(0)) + strNewQuery;
}

export { parseQuery, resolveQuery, stringifyQuery, concatLocalQuery };
